import { render } from "./boardOverview.vue?vue&type=template&id=cd03fbbc"
import script from "./boardOverview.vue?vue&type=script&lang=ts"
export * from "./boardOverview.vue?vue&type=script&lang=ts"
script.render = render

export default script